module.exports = __webpack_public_path__ + "static/img/9.1a400e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/9.png
// module id = wsax
// module chunks = 0